module.exports = __webpack_public_path__ + "img/logo_cbmmg.d359487a.png";